import React from "react";
import styled from "styled-components";

import * as css from "styles/CssVariables.js";

const Button = styled.div`
  box-sizing: border-box;
  height: 42px;
  padding: 0 30px;

  background: transparent;
  border-radius: 21px;
  border: 1px solid ${css.BRAND_BLUSH};

  font-family: "Roboto", sans-serif;
  font-weight: 400;
  font-size: 15px;
  color: ${css.BRAND_BLUSH};
  white-space: nowrap;

  transition: 0.2s;

  display: flex;
  justify-content: center;
  align-items: center;

  ${(props) =>
    !props.disabled &&
    `&:hover {
    cursor: pointer;

    color: #fff;

    background: ${css.BRAND_GREEN};
    border: 1px solid ${css.BRAND_GREEN};
  }`}
`;

export default (props) => {
  const { onClick, parameters, id, children, disabled } = props;
  return (
    <Button
      onClick={() => {
        if (disabled || !onClick) return;
        onClick(parameters);
      }}
      id={id}
      disabled={disabled}
    >
      {children}
    </Button>
  );
};
